import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowUpLeft: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-1-stroke-1.5-IconArrowUpLeft"><Path fillRule="evenodd" clipRule="evenodd" d="M16 6.25C16 5.55964 15.4404 5 14.75 5H6.25C5.55964 5 5 5.55964 5 6.25V14.75C5 15.4404 5.55964 16 6.25 16C6.94036 16 7.5 15.4404 7.5 14.75V9.26777L16.8661 18.6339C17.3543 19.122 18.1457 19.122 18.6339 18.6339C19.122 18.1457 19.122 17.3543 18.6339 16.8661L9.26777 7.5H14.75C15.4404 7.5 16 6.94036 16 6.25Z" fill="currentColor"/></CentralIconBase>;
});

export default IconArrowUpLeft;
